export const prescripteursBasePath = 'prescripteurs';
export const PRESCRIBER_LIST = '/prescripteurs/liste';
export const PRESCRIBER_NEW = '/prescripteurs/new';
export const SUB_TAB_ROUTER_PARAMETER = 'prescripteurSubTab';
